var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.343 10.3836L13.5977 12.6723C13.8967 12.9758 13.8967 13.4816 13.6102 13.7724C13.4607 13.9241 13.2614 14 13.0621 14C12.8627 14 12.6634 13.9241 12.5139 13.7724L10.2592 11.4837C9.39962 12.1286 8.32829 12.5205 7.18222 12.5205C4.32951 12.5205 2 10.1686 2 7.26027C2 4.36459 4.31705 2 7.18222 2C10.0349 2 12.3644 4.35195 12.3644 7.26027C12.3644 8.43625 11.9783 9.51106 11.343 10.3836ZM7.16976 3.56797C5.16414 3.56797 3.53224 5.22445 3.53224 7.26027C3.53224 9.30875 5.16414 10.9652 7.16976 10.9526C9.17538 10.9526 10.8073 9.2961 10.8073 7.26027C10.8073 5.22445 9.17538 3.56797 7.16976 3.56797Z",
    fill: "#001760"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9ab00a80.svg";
export { ForwardRef as ReactComponent };